<div class="mobile-page">
    <div class="content">
        <img class="logo" src="assets/images/logo.png" alt="Cooperativa Vinícola Garibaldi">
        <span class="icon"><mat-icon>phone_iphone</mat-icon></span>
        <h1>Use o aplicativo Minha Coop</h1>
        <p>O website Minha Coop não oferece suporte para dispositivos móveis. Acesse através de um computador ou baixe
            nosso aplicativo de forma gratuita.</p>
        <button type="button" mat-flat-button class="download-button" (click)="downloadApp()">
            <mat-icon>download</mat-icon> Baixar o aplicativo
        </button>
        <span class="version" *ngIf="appVersion?.version">Minha Coop v{{ appVersion?.version }}</span>
    </div>
</div>
